import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';
import { Tooltip, Props as TooltipProps } from './Tooltip';

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0px;
`;

const Label = styled.div`
  color: #9092c1;
  font-weight: 600;
  width: 150px;
  font-size: 13px;
  display: flex;
  align-items: center;
`;

const Value = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #171c3c;
  overflow-wrap: anywhere;
`;

const InfoIcon = styled.div`
  font-size: 11px;
  margin-left: 9px;
`;

const HoverContainer = styled.div`
  cursor: pointer;
`;

type Props = {
  label: string;
  children?: React.ReactNode;
  className?: string;
  tooltip?: TooltipProps;
};

export function InfoLabel({ label, children, className, tooltip }: Props) {
  const [showTooltip, setShowTooltip] = React.useState(false);

  return (
    <Container className={className}>
      <HoverContainer
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        tabIndex={-1}
      >
        <Label>
          {label}
          {tooltip && (
            <InfoIcon>
              <FontAwesomeIcon
                icon={faInfoCircle}
                color={'#9092C1'}
                size={'1x'}
              />
            </InfoIcon>
          )}
        </Label>
        {tooltip && showTooltip && <Tooltip {...tooltip} />}
      </HoverContainer>
      <Spacer horizontal spacing={2} />
      <Value>{children}</Value>
    </Container>
  );
}
